module.exports = __webpack_public_path__ + "img/portrait2thumb.d9e0272a.jpg";